// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"o2a-verify-email_wrapper__1cwfq","description":"o2a-verify-email_description__foJOu","resendBtn":"o2a-verify-email_resendBtn__2IVpY"};